import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { ServiceDeskAnalyticsContext } from '@jira/servicedesk__analytics/src/ServiceDeskAnalyticsContext.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import {
	lazyAfterPaint,
	type LazyComponent as LazyComponentType,
} from '@atlassian/react-loosely-lazy';
import type {
	ProjectBuilderProps,
	ProjectBuilder as ProjectBuilderDrawer,
} from './ProjectBuilder.tsx';

export const LazyComponent: LazyComponentType<(props: ProjectBuilderProps) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint<typeof ProjectBuilderDrawer>(
		() => import(/* webpackChunkName: "async-project-builder" */ './ProjectBuilder.tsx'),
		{ ssr: false },
	);

export const AsyncProjectBuilderDrawer = (
	props: Partial<ProjectBuilderProps>,
): React.JSX.Element => (
	<JSErrorBoundary
		id="bundle-async-project-builder"
		packageName="jira-servicedesk-project-builder"
		fallback="flag"
	>
		<Placeholder fallback={null} name="jsm-project-builder">
			<ServiceDeskAnalyticsContext>
				<LazyComponent isOpenInitial={!!props.isOpenInitial} {...props} />
			</ServiceDeskAnalyticsContext>
		</Placeholder>
	</JSErrorBoundary>
);

export const canUseProjectBuilder = (isAdmin: boolean): boolean => isAdmin;
